export enum BorderValues {
  BORDER_COLOR = 'color',
  BORDER_WIDTH = 'width',
  BORDER_STYLE = 'style',
}
